<template>
  <div>
    <vx-card>
      <vs-row vs-justify="center" class="mb-4">
        <h3>Summary</h3>
      </vs-row>
      <Question
        v-for="question in step.questions"
        :key="question.id"
        :question="question"
        :isEditable="meetingInstance.isEditable"
      />
    </vx-card>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";
export default {
  props: ["step", "meetingInstance"],
  components: { Question },
};
</script>

